export default {
  'confirm-yes': '是的，我确认',
  copay: '自付额：',
  cancel: '取消',
  'order-status': '订单状态：',
  'order-canceled': '订单已取消',
  'confirmed-back-to-pharmacy': '已确认退回药房',
  'on-its-way-to-pharmacy': '正在退回药房途中',
  'back-to-pharmacy': '已退回药房',
  'patient-signature': '患者签名',
  sign: '签名',
  'select-order-type': '选择订单类型',
  'preferred-eta': '首选送达时间',
  'recipient-instructions': '收件人特别说明',
  'add-special-instruction': '添加特别说明',
  'unable-to-change-address': '无法更改地址',
  'address-changed': '地址已成功更改',
  'start-typing': '开始输入',
  'full-address': '完整地址',
  'street-address': '街道地址',
  zip: '邮编',
  city: '城市',
  state: '州',
  apt: '公寓号',
  'app-store': '在 App Store 下载',
  'track-all-orders': '在一个应用中跟踪您的所有订单',
  zoom: '放大',
  unzoom: '缩小',
  'close-photo': '关闭',
  'feedback-call': '反馈电话',
  'feedback-message': '反馈消息',
  'feedback-close': '关闭反馈',
  close: '关闭',
}
